module.exports = __webpack_public_path__ + "img/widget-empty.9eb8ae16.png";